import { DateTime } from "luxon";

  export function getFormattedDate(date, timezone) {
    return (
      DateTime.fromISO(date, {
        zone: timezone,
      }).toFormat('LLLL d') +
      getNumberSuffix(
        DateTime.fromISO(date, {
          zone: timezone,
        }).toFormat('d'),
      ) +
      ' ' +
      DateTime.fromISO(date, {
        zone: timezone,
      }).toFormat('yyyy', { timeZone: timezone })
    );
  }

  export function getFormattedTime(shiftFrom: string, shiftTo:string, zone: string): string{
    return   DateTime.fromISO(shiftFrom, {
         zone,
       }).toFormat('h:mma') +
       ' - ' +
       DateTime.fromISO(shiftTo, {
         zone,
       }).toFormat('h:mma');
   }

   function getNumberSuffix(num : string) {
    const th = 'th';
    const rd = 'rd';
    const nd = 'nd';
    const st = 'st';

    if (num === '11' || num === '12' || num === '13') return th;

    let lastDigit = num.slice(-1);

    switch (lastDigit) {
      case '1':
        return st;
      case '2':
        return nd;
      case '3':
        return rd;
      default:
        return th;
    }
  }

